require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
// module id = 797
// module chunks = 0